
import {OSS_BUCKET, URL_CONFIG} from '@/url_config';
export const OSS_URL = URL_CONFIG.oss_url;

const handleResponse = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        let errorMessage = errorText;

        try {
            // 尝试解析为 JSON
            const errorJson = JSON.parse(errorText);
            if (errorJson.error) {
                errorMessage = errorJson.error; // 使用 JSON 中的 message 字段
            } else {
                errorMessage = JSON.stringify(errorJson); // 如果没有 message 字段，格式化 JSON
            }
        } catch (e) {
            // 如果解析失败，保持原始文本
            console.warn("Error parsing response as JSON:", errorText);
        }

        return { error: true, status: response.status, message: errorMessage };
    }

    const data = await response.json();
    return { error: false, status: response.status, data };
};
export const uploadOssFile = async (project_id, key, file, contentType = "") => {
    const bucket_name = OSS_BUCKET ;
    const formData = new FormData();
    formData.append("bucket_name", bucket_name);
    formData.append("file", file);
    formData.append("key", key);
    formData.append("content_type", contentType);

    try {
        const response = await fetch(`${OSS_URL}/upload`, {
            method: 'POST',
            body: formData,
        });
        return await handleResponse(response);
    } catch (err) {
        // 捕获非 HTTP 错误，例如网络问题
        return {
            error: true,
            status: 0, // 特殊标识网络错误
            message: err instanceof Error ? err.message : "Unknown error occurred",
        };
    }
};

export const getFileUrl = function (project_id, key) {
    const bucket_name = OSS_BUCKET ;
    return `${OSS_URL}/file/${bucket_name}/${key}`;
}

export const getTranslationUrl = function (uri) {
    return `${OSS_URL}/file/${uri}`;
}

